import React from "react";
import { Button, Chip, CircularProgress } from "@mui/joy";
import { PART_VAR_FIELDS, MappingStatus } from "./contractvarkeys";

//③ 파트 목록 테이블 (표시 전용). 탬플릿 변경·매핑은 편집 다이얼로그에서만 — 페이지 로드 시 유캔싸인 호출 없음

//매핑 상태 칩: 완료(초록) / 필드 N개 미연결(노랑) / 탬플릿 없음(회색)
export const renderMappingChip = (s: MappingStatus) => {
    if (!s || s.state === "noTemplate") {
        return <Chip size="sm" variant="soft" color="neutral">탬플릿 없음</Chip>;
    }
    if (s.state === "unmapped") {
        return <Chip size="sm" variant="soft" color="warning">필드 {s.unmappedCount}개 미연결</Chip>;
    }
    return <Chip size="sm" variant="soft" color="success">완료</Chip>;
};

const PartTable: React.FC<any> = (props) => {

    const parts: any[] = props.parts || [];

    if (props.loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <div style={{ overflowX: "auto" }}>
            <div style={{ minWidth: "1180px" }}>

                {/* 헤더 행 */}
                <div style={{ display: "flex", alignItems: "center", padding: "10px 4px", borderBottom: "1px solid #e0e0e0", fontSize: "13px", color: "#888", gap: "12px" }}>
                    <div style={{ width: "190px", flexShrink: 0 }}>파트</div>
                    <div style={{ width: "220px", flexShrink: 0 }}>유캔싸인 탬플릿</div>
                    {PART_VAR_FIELDS.map((f) => (
                        <div key={f.key} style={{ width: `${f.width}px`, flexShrink: 0 }}>{f.short}</div>
                    ))}
                    <div style={{ width: "120px", flexShrink: 0 }}>매핑</div>
                    <div style={{ width: "60px", flexShrink: 0 }}></div>
                </div>

                {parts.length === 0 &&
                    <div style={{ padding: "30px 4px", fontFamily: "Apple_R", color: "#9ca3af" }}>등록된 파트가 없습니다</div>
                }

                {parts.map((part) => (
                    <div key={part.id} style={{ display: "flex", alignItems: "center", padding: "10px 4px", borderBottom: "1px solid #f0f0f0", gap: "12px", fontSize: "13px", fontFamily: "Apple_R" }}>
                        <div style={{ width: "190px", flexShrink: 0, fontFamily: "Apple_SB", fontSize: "14px" }}>{part.name}</div>
                        <div
                            style={{ width: "220px", flexShrink: 0, color: part.templateName ? "#111" : "#9ca3af", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                            title={part.templateName || ""}
                        >
                            {part.templateId ? (part.templateName || part.templateId) : "(선택 안 함)"}
                        </div>
                        {PART_VAR_FIELDS.map((f) => (
                            <div key={f.key} style={{ width: `${f.width}px`, flexShrink: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={part.vars ? part.vars[f.key] : ""}>
                                {part.vars && part.vars[f.key] ? part.vars[f.key] : "-"}
                            </div>
                        ))}
                        <div style={{ width: "120px", flexShrink: 0 }}>{renderMappingChip(part.mappingStatus)}</div>
                        <div style={{ width: "60px", flexShrink: 0 }}>
                            <Button size="sm" variant="outlined" color="neutral" onClick={() => props.onEdit(part)}>편집</Button>
                        </div>
                    </div>
                ))}

            </div>
        </div>
    );
};

export default PartTable;
